import * as moment from "moment";
import {DistanceHeader} from "./views/distanceHeader";
import {sortOption} from "../../../shared/widgets/sortingView/sortingView";

export const markerLineColor = '#b0413e';
export var distanceFilterRange = {
    ALL: {
        key: "All",
        value: "All"
    }
};
export var gpsFilterRange = {
    ALL: {
        key: "All",
        value: "All"
    },
};

export const frequencyByRegionTemplateStrings = {
    vehicleNo: 'Vehicle No.',
    deviceId: 'Device Id',
    zeroToFive: {
        display: '0-5 sec',
        sortable: true,
        defaultSort: sortOption.ASC
    },
    fiveToTen: {
        display: '5-10 sec',
        sortable: true,
        defaultSort: sortOption.ASC
    },
    tenToTwenty: {
        display: '10-20 sec',
        sortable: true,
        defaultSort: sortOption.ASC
    },
    twentyToThirty: {
        display: '20-30 sec',
        sortable: true,
        defaultSort: sortOption.ASC
    },
    thirtyToSixty: {
        display: '30-60 sec',
        sortable: true,
        defaultSort: sortOption.ASC
    },
    sixtyToOneTwenty: {
        display: '60-120 sec',
        sortable: true,
        defaultSort: sortOption.ASC
    },
    greaterThanOneTwenty: {
        display: '120+ sec',
        sortable: true,
        defaultSort: sortOption.ASC
    },


};

export const RSUTemplateStrings={
    deviceId: 'ICCID',
    srId: 'SR Id',
    timestamp:{
        display:'Created Date',
        sortable: true,
        defaultSort: sortOption.DESC
    },
    createdBy: 'Created By',
    actions: 'Actions'
};

export const SMSStatusTemplateStrings={
    status: 'Status',
    number: 'Number',
    message: 'Message Sent',
    responseMessage:'Response Message',
    requestArrivedAt:{
        display:'Request Time',
        sortable: true,
        defaultSort: sortOption.DESC
    },
    responseArrivedAt:{
        display:'Response Time',
        sortable: true,
        defaultSort: sortOption.DESC
    },
    delay:{
        display:'Delay(sec)',
        sortable: true,
        defaultSort: sortOption.DESC
    },
    serviceProvider:'Provider',
};

export const viewListfrequencyByRegionTemplateStrings = {
    vehicleNo: 'Vehicle No.',
    color: 'Day',
    fromTimestamp: 'Date',
    zeroToFive: {
        display: '0-5 sec',
    },
    fiveToTen: {
        display: '5-10 sec',
    },
    tenToTwenty: {
        display: '10-20 sec',
    },
    twentyToThirty: {
        display: '20-30 sec',
    },
    thirtyToSixty: {
        display: '30-60 sec',
    },
    sixtyToOneTwenty: {
        display: '60-120 sec',
    },
    greaterThanOneTwenty: {
        display: '120+ sec',
    },
};

export const gpsQualityTemplateStrings = {
    vehicleNo: 'Vehicle',
    deviceId: 'Device Id',
    totalPoint: {
        display: 'GPS Count',
        sortable: true,
        defaultSort: sortOption.ASC
    }

};
export const health ={
    vehicle_no: 'Vehicle',
    device_id: 'Device Id',
    health: 'Status',
    distance: {
        display: 'Distance(Km)',
        sortable: true,
        defaultSort: sortOption.ASC
    },
    percentage: {
        display: 'Freq %(0-10sec)',
        sortable: true,
        defaultSort: sortOption.ASC
    },
    avgDelay: {
        display: 'Avg Delay(sec)',
        sortable: true,
        defaultSort: sortOption.ASC
    },
    delayPacketCount: {
        display: 'Delay Pkt Count(%)',
        sortable: true,
        defaultSort: sortOption.ASC
    },
    points: {
        display: 'GPS Point',
        sortable: true,
        defaultSort: sortOption.ASC
    },
    futureDatePoints: {
        display: 'Future Point(%)',
        sortable: true,
        defaultSort: sortOption.ASC
    },
    pastDatePoints: {
        display: 'Past Point(%)',
        sortable: true,
        defaultSort: sortOption.ASC
    },
    ignONCount:{
        display: 'Ign ON Count',
        sortable: true,
        defaultSort: sortOption.ASC
    },
    powerOnCount:{
        display: 'Power ON Count',
        sortable: true,
        defaultSort: sortOption.ASC
    },
    delay90thPercentile:{
        display: 'Delay 90 (%)',
        sortable: true,
        defaultSort: sortOption.ASC
    }
};

export const haltTemplateStrings ={
    device_id: 'Device Id',
    vehicleNo: 'Vehicle',
    latitude:'Latitude',
    longitude:'Longitude',
    startHaltTime:'Start Halt Time',
    endHaltTime:'End Halt Time',
};

export const gpsQualityDetailTemplateStrings = {
    totalPoint: 'GPS Count',
    totalFuturedatePoint: 'Future Date Points',
    totalPastdatePoint: 'Past Date Points',
    totalUniquePoint: 'Unique Points',
    totalZerolatlongPoint: 'Zero lat lng Points',
    packetIgnOnCount: 'Ign ON Count',
    packetPowerOnCount : 'Power ON Count',
    fromTimestamp: {
        display: 'Date',
        sortable: true,
        defaultSort: sortOption.ASC
    }
};


export const distanceTemplateStrings = {
    vehicleNo: 'Vehicle',
    deviceId: 'Device Id',
    odmDistance:'ODM Distance(Km)',
    distance: {
        component: DistanceHeader,
        display: 'GPS Count',
        sortable: true,
        defaultSort: sortOption.ASC
    },
};

export const distanceDetailTemplateStrings = {
    distance: {
        component: DistanceHeader
    },
    fromTimestamp: {
        display: 'Date',
        sortable: true,
        defaultSort: sortOption.ASC
    }
};

export const reportsType = {
    DISTANCE: 'distance',
    GPS_QUALITY: 'gpsQuality',
    GPS_QUALITY_DETAIL: ''
};

export const DepotReport={
    cityName:'City',
    depotName:'Depot Name',
    inVehicles: {
        display:'In Vehicle Count',
        sortable: true,
        defaultSort: sortOption.DESC
    },
    outVehicles: {
        display:'Out Vehicle Count',
        sortable: true,
        defaultSort: sortOption.DESC
    },
    unknownVehicles: {
        display:'Unknown Vehicle Count',
        sortable: true,
        defaultSort: sortOption.DESC
    },
    // inVehicles: 'In Vehicle Count',
    // outVehicles:'Out Vehicle Count',
    // unknownVehicles:'Unknown Vehicle Count'
}

export const DepotVehiclesDetail={
    vehicleNo: 'Vehicle',
    device_id:'DeviceId',
    agency:'Agency',
    operator:'Operator',
    timestamp:'Event Time',
}

export const BsdAvailablityReportHeadersConfig = {
    deviceId:'DeviceId',
    protocol:'Protocol',
    status:'Status'
}


export const EtaAckMatrixHeadersConfig = {
    deviceId:{
        display:"DeviceId",
        // sortable:true,
        // defaultSort: sortOption.DESC
    },
    totalNumberOfMsg:{
        display:"Total Message Sent",
        sortable:true,
        defaultSort: sortOption.DESC
    },
    totalNumberOfAck: {
        display:'Total Acknowledgement Received',
        sortable: true,
        defaultSort: sortOption.DESC
    },
    averageTimeDifference:{
        title: '(msg_sent_time - ack_rcvd_time)/total_ack_rcvd',
        display:"Average Time Difference",
        sortable:true,
        defaultSort: sortOption.DESC
    },
    city:{
        display:"City",
        // sortable:true,
        // defaultSort: sortOption.DESC
    }  
}

export function createLineGraphData(data, type) {
    return new Promise((resolve, reject)=> {
        try {
            let graphData = new Array();
            let dataKey = type === reportsType.DISTANCE ? 'distance' : 'totalPoint';
            graphData.push({id: type, data: [], color: '#309bf4'});
            data.sort((a, b)=> {
                return a['fromTimestamp'] - b['fromTimestamp'];
            });
            data.forEach((item)=> {
                let obj = {};
                obj['x'] = moment(item.fromTimestamp).format('YYYY-MM-DD');
                obj['y'] = item[dataKey];
                obj['fromTimestamp'] = item.fromTimestamp;
                graphData[0].data.push(obj);
            });
            resolve(graphData);
        }
        catch (err) {
            console.log("err", err);
            reject('error while extracting graph data');
        }
    })
}

export function createFrequencyGraphData(data){
    return new Promise((resolve, reject)=> {
        try {
            var days=[]
            for(var i=0;i<data.length;i++){
                days[i]=[];
            }
            for(var i=0;i<data.length;i++){
                days[i].push(data[i].fromTimestamp)
                days[i].push(data[i].zeroToFive)
                days[i].push(data[i].fiveToTen)
                days[i].push(data[i].tenToTwenty)
                days[i].push(data[i].twentyToThirty)
                days[i].push(data[i].thirtyToSixty)
                days[i].push(data[i].sixtyToOneTwenty)
                days[i].push(data[i].greaterThanOneTwenty)
            }
            resolve(days);
        }
        catch (err) {
            reject('error while extracting graph data');
        }
    })
}

export const VehicleInOutEventsHeaderConfig = {
    // id: "Vehicle Id",
    vehicleNo: "Vehicle No",
    deviceId: "Device Id",
    city: "City",
    agency: "Agency",
    depot: "Depot",
    operator: "Operator",
    // regionId: "Region Id",
    timestamp: "Time In Packet",
    // fromTimestamp: "From Timestamp",
    // toTimestamp: "To Timestamp",
    status: "Status"
}


export const DeviceConfigurationConfig={
    "deviceId": "Device Id",
    "command": "Command",
    "commandSentAt": "Cmd Sent At",
    "commandStatus": "Cmd Status",
    "commandResponseStatus": "Cmd Response Status",
    "commandResponse": "Cmd Response",
    "action":"Action"
};

function getScaleInfo(lowerRange, upperRange) {
    const scale = upperRange ? `${lowerRange}-${upperRange}` : `${lowerRange}+`;
    const value = upperRange ? `${lowerRange} to ${upperRange}` : `greater than ${lowerRange}`;
    return { scale, value };
}

function initFilterRange(scales, filterRange) {
    scales.forEach(item => {
        const { scale, value } = getScaleInfo(item.lowerRange, item.upperRange);
        filterRange[scale] = { key: scale, value, slab: item.slab, lowerRange: item.lowerRange, upperRange: item.upperRange };
    });
}

const distanceScales = [
    { slab: "slabOne", slabKey: "slabOneDeviceCount", lowerRange: 0, upperRange: 25 },
    { slab: "slabTwo", slabKey: "slabTwoDeviceCount", lowerRange: 25, upperRange: 50 },
    { slab: "slabThree", slabKey: "slabThreeDeviceCount", lowerRange: 50, upperRange: 75 },
    { slab: "slabFour", slabKey: "slabFourDeviceCount", lowerRange: 75, upperRange: 100 },
    { slab: "slabFive", slabKey: "slabFiveDeviceCount", lowerRange: 100, upperRange: 125 },
    { slab: "slabSix", slabKey: "slabSixDeviceCount", lowerRange: 125, upperRange: 150 },
    { slab: "slabSeven", slabKey: "slabSevenDeviceCount", lowerRange: 150, upperRange: 175 },
    { slab: "slabEight", slabKey: "slabEightDeviceCount", lowerRange: 175, upperRange: 200 },
    { slab: "slabNine", slabKey: "slabNineDeviceCount", lowerRange: 200, upperRange: null },
];

const gpsQualityScales = [
    { slab: "slabOne", slabKey: "slabOneDeviceCount", lowerRange: 0, upperRange: 500 },
    { slab: "slabTwo", slabKey: "slabTwoDeviceCount", lowerRange: 500, upperRange: 1000 },
    { slab: "slabThree", slabKey: "slabThreeDeviceCount", lowerRange: 1000, upperRange: 1500 },
    { slab: "slabFour", slabKey: "slabFourDeviceCount", lowerRange: 1500, upperRange: 2000 },
    { slab: "slabFive", slabKey: "slabFiveDeviceCount", lowerRange: 2000, upperRange: 2500 },
    { slab: "slabSix", slabKey: "slabSixDeviceCount", lowerRange: 2500, upperRange: 3000 },
    { slab: "slabSeven", slabKey: "slabSevenDeviceCount", lowerRange: 3000, upperRange: null },
];

initFilterRange(distanceScales, distanceFilterRange);
initFilterRange(gpsQualityScales, gpsFilterRange);

export function mapApiResponseToGraphData(apiResponse, type) {
    const scales = type === reportsType.DISTANCE ? distanceScales : gpsQualityScales;
    
    return scales.map((item) => {
        const { scale } = getScaleInfo(item.lowerRange, item.upperRange);
        return {
            scale,
            count: apiResponse[item.slabKey] || 0,
            countColor: "#309bf4",
        };
    });
}